import * as _ from "lodash";

const interpolationRegex = /(\\*)#/g;

// Replace any unescaped occurences of "#" with the value
function interpolateValue(value: number, str: string) {
	if (str == null)
		return str;

	// TODO: Deal with backslashes that don't precede a "#" character

	return str.replace(interpolationRegex, function(_, backslashes: string) {
		// The replacement character could be preceded by any number of escaped backslashes:
		// "\\\\" and "\\\\\" both turn into "\\" in the output, with the last backslash in the latter
		// example serving to escape the replacement character.
		let outputBackslashes = backslashes.slice(0, Math.floor(backslashes.length / 2));

		if (backslashes.length % 2 === 0)
			return outputBackslashes + value;
		else
			// The interpolation character is preceded by an odd number of backslashes, so it
			// is escaped.
			return outputBackslashes + "#";
	});
}

function pluralize(value: number, strings: Array<string> | Record<string, string>): string;
function pluralize(value: number, offset: number, strings: Array<string> | Record<string, string>): string;
function pluralize(value: number, offsetOrStrings: number | Array<string> | Record<string, string>, strings?: Array<string> | Record<string, string>): string {
	let offset: number;
	if (typeof offsetOrStrings !== "number") {
		strings = offsetOrStrings;
		offset = 0;
	}
	else {
		offset = offsetOrStrings;
	}

	// Allow pluralize(x, ['foo', 'foos']) as a shorthand
	if (_.isArray(strings)) {
		strings = {
			one: strings[0],
			other: strings[1],
		};
	}

	let offsetValue = value - offset;

	if (value in strings)
		return interpolateValue(offsetValue, strings[value]);

	let pluralCategory = (offsetValue === 1) ? "one" : "other";
	if (pluralCategory in strings)
		return interpolateValue(offsetValue, strings[pluralCategory]);

	// Might be undefined
	return interpolateValue(offsetValue, strings.other);
}

namespace pluralize {

}

export = pluralize;
